<template>
  <div>
    <md-toolbar>
      <md-button @click="$router.go(-1)" class="md-icon-button">
        <md-icon>keyboard_backspace</md-icon>
      </md-button>
      <span>{{ title }}</span>
    </md-toolbar>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
